var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 13.614 2.40351 15.1754 3.07018 16.5263L2.4386 19.1579C2.08772 20.614 3.38596 21.9123 4.84211 21.5614L7.47368 20.9298C8.82456 21.5965 10.386 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12ZM6.66667 12C6.66667 11.2632 7.26316 10.6667 8 10.6667C8.73684 10.6667 9.33333 11.2632 9.33333 12C9.33333 12.7368 8.73684 13.3333 8 13.3333C7.26316 13.3333 6.66667 12.7368 6.66667 12ZM10.6667 12C10.6667 11.2632 11.2632 10.6667 12 10.6667C12.7368 10.6667 13.3333 11.2632 13.3333 12C13.3333 12.7368 12.7368 13.3333 12 13.3333C11.2632 13.3333 10.6667 12.7368 10.6667 12ZM14.6667 12C14.6667 11.2632 15.2632 10.6667 16 10.6667C16.7368 10.6667 17.3333 11.2632 17.3333 12C17.3333 12.7368 16.7368 13.3333 16 13.3333C15.2632 13.3333 14.6667 12.7368 14.6667 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.49b80fea.svg";
export { ForwardRef as ReactComponent };